import { ConstructionSiteModel } from "./construction-site.model";

export class UpdateStateClientResponseModel {
  clientId: number = 0;
  clientStateId: number = 0;
  stateChangeDate: Date = new Date(0, 0, 0, 0, 0, 0);
  updateConstructionSite: boolean = false;
  constructionSiteStateId: number = 0;
}